import React from 'react';
import { Link, useLocation } from 'react-router';
import { usePaths } from '../Routes/RouterList';
import { useLessThen991 } from '../../utils/mediaQuery';
import { useDispatch, useSelector } from 'react-redux';
import { selectorsLocale } from '../../redux/locale/localeReducer';
import { buildLocale } from '../../utils/buildLocale';
import cardIcon from '../../assets/images/card-icon.png';
import paypalIcon from '../../assets/images/paypal-icon.png';
import { actionsFilters } from '../../redux/filters/filtersReducer';
import { selectorsOther } from '../../redux/other/otherReducer';

const FooterComponent: React.FC = (props) => {
  const currentTranslate = useSelector(selectorsLocale.getTranslate);
  const dispatch: any = useDispatch();
  const paths = usePaths();
  const location = useLocation();
  const isDesktop = useSelector(selectorsOther.isDesktop);
  const isLessThen991 = useLessThen991(isDesktop);

  if (isLessThen991 && (location.pathname.endsWith(paths.login) || location.pathname.endsWith(paths.signup))) {
    return null;
  }

  return (
    <footer className="footer">
      <section className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-6 col-md-4">
              <div className="footer-email">
                <a href={`mailto:${buildLocale(currentTranslate, 'footerEmail1')}`} className="footer-contact">
                  <span className="icon icon-email"></span>
                  {buildLocale(currentTranslate, 'footerEmail1')}
                </a>
                <p className="add-text">{buildLocale(currentTranslate, 'footerEmailDescription1')}</p>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <div className="footer-email">
                <a href={`mailto:${buildLocale(currentTranslate, 'footerEmail2')}`} className="footer-contact">
                  <span className="icon icon-email"></span>
                  {buildLocale(currentTranslate, 'footerEmail2')}
                </a>
                <p className="add-text">{buildLocale(currentTranslate, 'footerEmailDescription2')}</p>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <div className="footer-partner">
                <a href={`mailto:${buildLocale(currentTranslate, 'footerEmail3')}`} className="footer-contact">
                  <span className="icon icon-email"></span>
                  {buildLocale(currentTranslate, 'footerPartnerTitle')}
                </a>
                <p className="add-text">{buildLocale(currentTranslate, 'footerPartnerSubtitle')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="container">
        <div className="row footer-bottom">
          <div className="col-12 col-sm-6 col-md-4">
            <p className="footer-title">{buildLocale(currentTranslate, 'headerAboutCompany')}</p>
            <ul className="footer-menu">
              <li>
                <Link to={paths.about_us} onClick={() => dispatch(actionsFilters.clearAllSelected())}>
                  {buildLocale(currentTranslate, 'footerAboutUs')}
                </Link>
              </li>
              <li>
                <Link to={paths.regional_products} onClick={() => dispatch(actionsFilters.clearAllSelected())}>
                  {buildLocale(currentTranslate, 'footerRegionalProducts')}
                </Link>
              </li>
              <li>
                <Link to={paths.regional_partners} onClick={() => dispatch(actionsFilters.clearAllSelected())}>
                  {buildLocale(currentTranslate, 'footerRegionalPartners')}
                </Link>
              </li>
              <li>
                <Link to={paths.brands} onClick={() => dispatch(actionsFilters.clearAllSelected())}>
                  {buildLocale(currentTranslate, 'brandsFooter')}
                </Link>
              </li>
              <li>
                <Link to={paths.bio_badges} onClick={() => dispatch(actionsFilters.clearAllSelected())}>
                  {buildLocale(currentTranslate, 'footerBioBadges')}
                </Link>
              </li>
              <li>
                <Link to={paths.delivery} onClick={() => dispatch(actionsFilters.clearAllSelected())}>
                  {buildLocale(currentTranslate, 'footerDelivery')}
                </Link>
              </li>
              <li>
                <Link to={paths.produktrueckrufe} onClick={() => dispatch(actionsFilters.clearAllSelected())}>
                  {buildLocale(currentTranslate, 'footerProduktrueckrufe')}
                </Link>
              </li>
              <li>
                <Link to={paths.presse} onClick={() => dispatch(actionsFilters.clearAllSelected())}>
                  {buildLocale(currentTranslate, 'footerPresse')}
                </Link>
              </li>
              {location && location.pathname.includes('pay-page') && (
                <li>
                  <a href="https://join.com/companies/mybio" target="_blank" rel="noreferrer">
                    {buildLocale(currentTranslate, 'footerCarreer')}
                  </a>
                </li>
              )}
              <li>
                <Link to={paths.faq} onClick={() => dispatch(actionsFilters.clearAllSelected())}>
                  {buildLocale(currentTranslate, 'footerFaq')}
                </Link>
              </li>
              <li>
                <Link to={paths.agb} onClick={() => dispatch(actionsFilters.clearAllSelected())}>
                  {buildLocale(currentTranslate, 'footerAgb')}
                </Link>
              </li>
              <li>
                <Link to={paths.widerrufsrecht} onClick={() => dispatch(actionsFilters.clearAllSelected())}>
                  {buildLocale(currentTranslate, 'footerWiderrufsrecht')}
                </Link>
              </li>
              <li>
                <Link to={paths.confidentiality} onClick={() => dispatch(actionsFilters.clearAllSelected())}>
                  {buildLocale(currentTranslate, 'footerConfid')}
                </Link>
              </li>
              <li>
                <Link to={paths.impressum} onClick={() => dispatch(actionsFilters.clearAllSelected())}>
                  {buildLocale(currentTranslate, 'footerImpressum')}
                </Link>
              </li>
            </ul>

            <p className="footer-add">{buildLocale(currentTranslate, 'footerOko')}</p>
          </div>
          <div className="col-12 col-sm-6 col-md-4 footer-payment">
            <div className="footer-payment_content">
              <p className="footer-title">{buildLocale(currentTranslate, 'footerPaymentDetails')}</p>
              <ul className="footer-payment_list">
                <li>
                  <img src={cardIcon} alt="" width="30" height="30" />
                  <span>{buildLocale(currentTranslate, 'footerPaymentCard')}</span>
                </li>
                <li>
                  <img src={paypalIcon} alt="" width="30" height="30" />
                  <span>{buildLocale(currentTranslate, 'footerPaymentPaypal')}</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="footer-social">
              <div className="footer-title">{buildLocale(currentTranslate, 'footerFollow')}</div>
              <ul className="footer-social_list">
                <li>
                  <a
                    rel="noopener, ,noindex,nofollow noreferrer"
                    href="https://www.facebook.com/mybiogmbh"
                    target="_blank"
                    className="icon-facebook"
                    aria-label="Facebook">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M16 32C7.16325 32 0 24.8367 0 16C0 7.16325 7.16325 -2.16166e-06 16 -2.16166e-06C24.8367 -2.16166e-06 32 7.16325 32 16C32 24.8367 24.8367 32 16 32Z"
                        fill="#345EA9"
                      />
                      <path
                        d="M13.5615 25.6729H17.4564V15.9192H20.1734L20.4633 12.6533H17.4564C17.4564 12.6533 17.4564 11.434 17.4564 10.7933C17.4564 10.0237 17.6107 9.71903 18.3553 9.71903C18.9545 9.71903 20.4633 9.71903 20.4633 9.71903V6.33008C20.4633 6.33008 18.2411 6.33008 17.7664 6.33008C14.8683 6.33008 13.5615 7.60651 13.5615 10.0496C13.5615 12.1778 13.5615 12.6533 13.5615 12.6533H11.5352V15.9598H13.5615V25.6729Z"
                        fill="white"
                      />
                    </svg>
                  </a>
                </li>
                <li>
                  <a
                    rel="noopener, ,noindex,nofollow noreferrer"
                    href="https://www.instagram.com/mybio.de/"
                    target="_blank"
                    className="icon-instagram"
                    aria-label="Instagram">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M16 32.0005C7.16325 32.0005 0 24.8372 0 16.0005C0 7.16374 7.16325 0.00048612 16 0.00048612C24.8367 0.00048612 32 7.16374 32 16.0005C32 24.8372 24.8367 32.0005 16 32.0005Z"
                        fill="url(#paint0_radial)"
                      />
                      <path
                        d="M15.9994 7.22757C13.6171 7.22757 13.3181 7.23783 12.3826 7.28066C11.4488 7.32304 10.8108 7.47161 10.2532 7.68844C9.67586 7.9124 9.1869 8.21221 8.69927 8.70028C8.21119 9.18792 7.91138 9.67733 7.68742 10.2542C7.47059 10.8123 7.32203 11.4499 7.27965 12.3836C7.23682 13.3192 7.22656 13.6181 7.22656 16.0005C7.22656 18.3833 7.23682 18.6818 7.27965 19.6178C7.32203 20.5516 7.47059 21.1891 7.68742 21.7473C7.91138 22.3241 8.21119 22.8135 8.69927 23.3012C9.1869 23.7888 9.67586 24.0891 10.2532 24.313C10.8108 24.5298 11.4488 24.678 12.3826 24.7208C13.3181 24.7636 13.6171 24.7734 15.9994 24.7734C18.3823 24.7734 18.6807 24.7636 19.6167 24.7208C20.5505 24.678 21.1881 24.5298 21.7462 24.313C22.323 24.0891 22.812 23.7888 23.3001 23.3012C23.7877 22.8135 24.0875 22.3241 24.3119 21.7473C24.5287 21.1891 24.6769 20.5516 24.7197 19.6178C24.7621 18.6818 24.7723 18.3833 24.7723 16.0005C24.7723 13.6181 24.7621 13.3192 24.7197 12.3836C24.6769 11.4499 24.5287 10.8123 24.3119 10.2542C24.0875 9.67733 23.7877 9.18792 23.3001 8.70028C22.812 8.21221 22.323 7.9124 21.7462 7.68844C21.1881 7.47161 20.5505 7.32304 19.6167 7.28066C18.6807 7.23783 18.3823 7.22757 15.9994 7.22757ZM15.9994 8.80825C18.3421 8.80825 18.6196 8.81718 19.5445 8.85956C20.3997 8.89837 20.8642 9.04158 21.1738 9.16159C21.5829 9.32086 21.8751 9.51093 22.1821 9.81787C22.4894 10.1248 22.679 10.417 22.8383 10.8266C22.9588 11.1358 23.1015 11.6002 23.1404 12.4559C23.1827 13.3808 23.1917 13.6583 23.1917 16.0005C23.1917 18.3432 23.1827 18.6207 23.1404 19.5455C23.1015 20.4012 22.9588 20.8657 22.8383 21.1744C22.679 21.5844 22.4894 21.8762 22.1821 22.1836C21.8751 22.4901 21.5829 22.6806 21.1738 22.8394C20.8642 22.9599 20.3997 23.1026 19.5445 23.1419C18.6196 23.1838 18.3421 23.1927 15.9994 23.1927C13.6568 23.1927 13.3797 23.1838 12.4544 23.1419C11.5992 23.1026 11.1347 22.9599 10.8256 22.8394C10.416 22.6806 10.1238 22.4901 9.81684 22.1836C9.5099 21.8762 9.31984 21.5844 9.16057 21.1744C9.04056 20.8657 8.89735 20.4012 8.85853 19.5455C8.81615 18.6207 8.80768 18.3432 8.80768 16.0005C8.80768 13.6583 8.81615 13.3808 8.85853 12.4559C8.89735 11.6002 9.04056 11.1358 9.16057 10.8266C9.31984 10.417 9.5099 10.1248 9.81684 9.81787C10.1238 9.51093 10.416 9.32086 10.8256 9.16159C11.1347 9.04158 11.5992 8.89837 12.4544 8.85956C13.3797 8.81718 13.6572 8.80825 15.9994 8.80825Z"
                        fill="white"
                      />
                      <path
                        d="M15.9993 18.9242C14.3842 18.9242 13.0753 17.6148 13.0753 15.9997C13.0753 14.3847 14.3842 13.0757 15.9993 13.0757C17.6143 13.0757 18.9237 14.3847 18.9237 15.9997C18.9237 17.6148 17.6143 18.9242 15.9993 18.9242ZM15.9993 11.495C13.5116 11.495 11.4941 13.5116 11.4941 15.9997C11.4941 18.4879 13.5116 20.5049 15.9993 20.5049C18.4874 20.5049 20.5044 18.4879 20.5044 15.9997C20.5044 13.5116 18.4874 11.495 15.9993 11.495Z"
                        fill="white"
                      />
                      <path
                        d="M21.7366 11.3172C21.7366 11.899 21.2651 12.3701 20.6837 12.3701C20.102 12.3701 19.6309 11.899 19.6309 11.3172C19.6309 10.7359 20.102 10.2648 20.6837 10.2648C21.2651 10.2648 21.7366 10.7359 21.7366 11.3172Z"
                        fill="white"
                      />
                      <defs>
                        <radialGradient
                          id="paint0_radial"
                          cx="0"
                          cy="0"
                          r="1"
                          gradientUnits="userSpaceOnUse"
                          gradientTransform="translate(-0.800826 32.1071) rotate(-43.8767) scale(59.1654)">
                          <stop offset="0" stopColor="#ECEF39" />
                          <stop offset="0.241206" stopColor="#F4713C" />
                          <stop offset="0.488797" stopColor="#ED2981" />
                          <stop offset="1" stopColor="#3252AC" />
                        </radialGradient>
                      </defs>
                    </svg>
                  </a>
                </li>
                <li>
                  <a
                    rel="noreferrer noopener noindex nofollow"
                    href="https://www.youtube.com/@mybiogmbh"
                    target="_blank"
                    className="icon-youtube"
                    aria-label="YouTube">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15.9998 32.0005C7.16361 32.0005 0 24.8369 0 16.0008V16.0002C0 7.16414 7.16361 0.00048612 15.9998 0.00048612C24.8364 0.00048612 32 7.16414 32 16.0002V16.0008C32 24.8369 24.8364 32.0005 15.9998 32.0005Z"
                        fill="#EC2725"
                      />
                      <path
                        d="M25.199 11.5994C24.9783 10.8127 24.3278 10.193 23.5016 9.98282C22.0042 9.60059 16.0002 9.60059 16.0002 9.60059C16.0002 9.60059 9.99623 9.60059 8.49916 9.98282C7.67303 10.193 7.0225 10.8127 6.80141 11.5994C6.40039 13.0254 6.40039 16.0003 6.40039 16.0003C6.40039 16.0003 6.40039 18.9755 6.80141 20.4015C7.0225 21.1883 7.67303 21.808 8.49916 22.0182C9.99623 22.4004 16.0002 22.4004 16.0002 22.4004C16.0002 22.4004 22.0042 22.4004 23.5016 22.0182C24.3278 21.808 24.9783 21.1883 25.199 20.4015C25.6004 18.9755 25.6004 16.0003 25.6004 16.0003C25.6004 16.0003 25.6004 13.0254 25.199 11.5994Z"
                        fill="white"
                      />
                      <path d="M14.4004 18.4004V13.6006L19.2004 16.0006L14.4004 18.4004Z" fill="#EC2725" />
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterComponent;
